<template>
  <div>
    <button
      type="button"
      class="btn btn-primary"
      data-bs-toggle="modal"
      data-bs-target="#chooseProduct"
    >
      {{ 'Add product' | translate }}
    </button>

    <div class="modal fade" id="chooseProduct" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ 'Add product' | translate }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              
            </button>
          </div>
          <div class="modal-body text-start">
            <div class="mb-3">
              <label class="fw-bold" for="courseTitle">
                {{ 'Title' | translate }}
              </label>
              <input
                v-model="productData.title"
                type="text"
                class="form-control"
                id="courseTitle"
                :placeholder="$t('Example: How to make your first cake')"
              />
            </div>
            <label class="fw-bold">
              {{ 'Choose type' | translate }}
            </label>
            <div class="form-check mb-3">
              <input
                class="form-check-input"
                type="radio"
                id="onlineCourse"
                value="course"
                name="productType"
                v-model="productData.type"
              />
              <label class="form-check-label" for="onlineCourse">
                <span>{{ 'Online course' | translate }}</span>
                <br />
                <small class="text-muted">
                  {{'Create a series of lessons with video, images and other types of content' | translate}}
                </small>
              </label>
            </div>

            <div class="form-check mb-3">
              <input
                class="form-check-input"
                type="radio"
                id="bundleCourse"
                name="productType"
                value="bundle"
                v-model="productData.type"
              />
              <label class="form-check-label" for="bundleCourse">
                <span>{{ 'Bundle' | translate }}</span>
                <br />
                <small class="text-muted"
                  >{{'Sell a collection of online courses' | translate}}</small
                >
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                id="consultation"
                name="productType"
                value="consultation"
                v-model="productData.type"
              />
              <label class="form-check-label" for="consultation">
                <span>{{ 'Online consultation' | translate }}</span>
                <br />
                <small class="text-muted"
                  >{{'Sell online consultation (one on one)' | translate}}</small
                >
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                id="file"
                name="productType"
                value="file"
                v-model="productData.type"
              />
              <label class="form-check-label" for="file">
                <span>{{ 'File over email' | translate }}</span>
                <br />
                <small class="text-muted"
                  >{{'PDF or ZIP' | translate}}</small
                >
              </label>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              {{ 'Nevermind' | translate }}
            </button>
            <button v-if="loading" class="btn btn-primary" type="button" disabled>
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Loading...
            </button>
            <button v-else @click="createProduct" type="button" class="btn btn-primary">
              {{ 'Add product' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      productData: {
        title: '',
        type: 'course',
      },
    }
  },
  methods: {
    createProduct() {
      this.loading = true
      axios
        .post('/home/courses/js', this.productData)
        .then(({ data }) => {
          window.location.href = `/home/courses/${data.id}`
        })
        .catch((error) => {
          this.loading = false
          if (error.response && error.response.status === 422) {
            iziToast.warning({
              title: 'Warning',
              message: this.$t('Validation error'),
              position: 'bottomLeft',
            })
          } else {
            console.error(error)
          }
        })
    },
  },
}
</script>

<style></style>
